import * as actionTypes from './actionsTypes';

export const setCurrentPageSuivi = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_SUIVI,
  payload: page
});

export const setValueSuivi = (value) => ({
  type: actionTypes.SET_VALUE_SUIVI,
  payload: value
});
export const setStatutSuivi = (statut) => ({
  type: actionTypes.SET_STATUT_SUIVI,
  payload: statut
});


export const setSortFieldSuivi = (field) => ({
  type: actionTypes.SET_SORT_FIELD_SUIVI,
  payload: field
});

export const setOrderSuivi = (order) => ({
  type: actionTypes.SET_ORDER_SUIVI,
  payload: order
});

